module.exports = function anonymous(it
/*``*/) {
var out=''+(it.Address1)+'<br />';if(it.Address2){out+=''+(it.Address2)+'<br />';}out+=''+(it.City)+'<br />'+(it.PostCode)+'<br /><a class="link-warning" href="#" data-address-edit>Edit address</a>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./source/scripts/templates/addressDisplay.dot
// module id = 117
// module chunks = 0